import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["bgColor", "mediaSide", "media", "description"];
import { CUICard } from 'connect-dot-com-ui-components/Components/CUICard/CUICard';
import { CUIHStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
/**
- A CUIHomepageCard should contain a `CUIHomepageCardDescriptionSection` and a `CUIHomepageCardImageSection`.
- CUIHomepageCard will hide the media on smaller viewports, hence the need for the `mediaSide` prop
**/
const CUIHomepageCard = _ref => {
  let {
      bgColor,
      mediaSide,
      media,
      description
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIHStack, {
    bgColor: bgColor,
    w: "100%",
    justifyContent: "center",
    py: 5,
    children: /*#__PURE__*/_jsxs(CUICard, Object.assign({
      borderRadius: 0,
      boxShadow: "none",
      direction: {
        base: 'column',
        md: `row${mediaSide === 'left' ? '' : '-reverse'}`
      },
      overflow: "hidden",
      size: "lg",
      padding: 0,
      maxW: "1000px"
    }, rest, {
      children: [media, description]
    }))
  });
};
export default CUIHomepageCard;